import {Component, EventEmitter, OnInit, Output, Input, OnChanges} from '@angular/core';
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {ValidationCodeVm} from 'src/app/view-model/validation-code/validation-code.vm';
import {onlyNumbersValidator} from '../../custom-validators/only-numbers-validator';
import { UpdateNotificationModalEvent } from '../../event-listeners/update-notification-modal/update-notification-modal.event';
import {FormErrorValidatorService} from '../../services/form-error-validator.service';
import {countryConfig} from 'src/country-config/country-config';
import { UpdateSessionModalEvent } from '../../event-listeners/update-session-modal/update-session-modal.event';
import { Router } from '@angular/router';
import { SupportVm } from 'src/app/view-model/support/support.vm';
import {Store} from '@ngxs/store';
import {SaveCustomer} from 'src/app/data/actions/customer.actions';
import {SessionEvent} from '../../event-listeners/session/session.event';

@Component({
  selector: 'app-validate-code',
  templateUrl: './validate-code.component.html',
  styleUrls: ['./validate-code.component.scss'],
})
export class ValidateCodeComponent implements OnInit, OnChanges {
  @Input() idPrefix = '';
  @Input() listCustomer;
  @Input() customer;
  @Input() from;
  @Input() isModal = false;
  @Input() selfCheckout = false;
  @Output() loggedIn = new EventEmitter<any>();
  @Output() validated = new EventEmitter<any>();
  @Input() choice;

  smsValidationForm: FormGroup;
  idCustomer;
  message;
  reSendDisabled = true;
  isFirstReSend = true;
  isSecondReSend = false;
  isLoading = false;
  isTokenValid = false;
  showWhatsApp = false;
  smsToken = '';
  smsTokenAlgolia = '';
  error = {
    token: '',
  };
  errorObj: any;
  countDownCounter = 0;
  hideReSend;
  sendAlgolia = false;
  indexMessage;
  tokenFTD;
  sendMethod;
  idCustomerWebSafeAnonymous = '';
  public swZdWidget = false;
  public countryConfig = countryConfig;
  public selectCustomer: any;
  public counter: number = 1;

  public showChangeMethodCode: boolean;
  sendMethodText = {
    sms: 'SMS',
    email: 'Correo electrónico',
    whatsapp: 'WhatsApp',
    call: 'Llamada telefónica',
  };


  get target(): string {
    const listCustomer = this.listCustomer?.[0] || this.listCustomer;
    if(listCustomer){
      const keyEmail = 'email';
      const keyPhone = 'phone';
      const keyToSearch = this.isEmailTarget() ? keyEmail : keyPhone;

      return listCustomer?.list?.find(item => item?.type === keyToSearch)?.data;
    }else{
      if(this.customer && this.customer.list){
        return this.customer.list[0].data;
      }else{
        return this.choice.data;
      }
    }
  }

  isEmailTarget() : boolean {

    if (this.sendMethod) {
      const isSendMethodEmail = this.sendMethod === this.sendMethodText.email;
      if (isSendMethodEmail) { return true; }

      return false;
    }

    if( this.from === 'remember' ){
      return this.choice.data.includes('@');
    }else if( this.from === 'login' ){
      return false;
    }else if( this.from === 'select' ){
      return false;
    }
  }

  constructor(private formBuilder: FormBuilder,
    private fev: FormErrorValidatorService,
    private vm: ValidationCodeVm,
    private notificationModalEvent: UpdateNotificationModalEvent,
    private sessionModalStatusEvent: UpdateSessionModalEvent,
    private router: Router,
    private supportVm: SupportVm,
    private store: Store,
    private sessionEvent: SessionEvent
  ) { }

  initSmsValidationForm() {
    this.smsValidationForm = this.formBuilder.group({
      token: new FormControl('', [onlyNumbersValidator, Validators.required, Validators.maxLength(6), Validators.minLength(6)]),
    });
  }

  countDown() {
    this.countDownCounter = this.vm.getConfigurationModules('sms-lasting-time');
    const interval = setInterval(() => {
      this.countDownCounter -= 1;

      if (this.countDownCounter <= 0) {
        this.reSendDisabled = false;
        clearInterval(interval);
        this.countDownCounter = -1;
      }
    }, 1000);
  }


  reSendTimer() {
    this.countDown();
    const delay = 20000;
    this.reSendDisabled = true;
    setTimeout(() => {
      this.reSendDisabled = false;
    }, delay);
  }

  reSend() {
    this.vm.sendMessage('phone', this.customer ? this.customer.idCustomer : this.idCustomer).subscribe(() => {
      this.reSendTimer();
    });
  }

  sendEmail() {
    this.vm.sendMessage('email', this.customer ? this.customer.idCustomer : this.idCustomer).subscribe();
  }

  validate() {
    this.message = '';

    const getPotencialCustomer = this.vm.getitemSessionStorage('potencialCustomerExpress');

    this.idCustomerWebSafeAnonymous = this.vm.getLocalStorage('customer')?.idCustomerWebSafe;

    if (this.smsValidationForm.valid && (this.idCustomer || getPotencialCustomer)) {
      this.isLoading = true;
      this.vm.validateToken(this.smsValidationForm.controls.token.value, this.idCustomer).subscribe({
        next: (res) => {
          if (getPotencialCustomer) {
            this.sessionModalStatusEvent.changeModalStatus({close: true});
            this.router.navigate(['/finaliza-el-registro'], {
              queryParams: {
                selfCheckout: this.selfCheckout ?? false,
              },
            });
            return;
          }

          if (res?.customerId) {
            this.customer = {...this.customer, ...res};
            this.saveCustomer(this.customer);
            this.logIn();

            if(this.counter === 1){
              this.sessionModalStatusEvent.updatedOrigin.subscribe( origin =>{
                this.router.navigate(['/']);
                if(origin.notification){
                  this.notificationModalEvent.changeModalStatus( {open: true} );
                  this.counter += 1;
                }
              } );
            }
          } else {
            this.isLoading = false;
            this.message = 'El codigo no es valido.';
          }
        },
        complete: () => {  },
        error: (error) => {
          this.isLoading = false;
          this.message = error.message || 'Se han producido demasiados intentos fallidos. Usa otra opción para el inicio de sesión o contacta a soporte.'
        }
      });
    }
  }

  changeMethodOfCode(){
    this.showChangeMethodCode = true;
  }

  logIn() {
    this.vm.customerOnly(this.customer).subscribe(customerOnly => {
      this.saveCustomer(customerOnly);
      this.loggedIn.emit(customerOnly);
      this.vm.mergeCarts(this.idCustomerWebSafeAnonymous).subscribe();
    })
  }

  closeSelect( event ){
    if(event.close){
      this.message = '';
      this.clearToken();
      this.showChangeMethodCode = false;
    }
  }

  handleSendMethod(event) {
    const selectedMethod = Object.entries(event).find(([key, value]) => value === true)?.[0];

    switch (selectedMethod) {
      case 'bySMS':
        this.sendMethod = 'SMS';
        break;
      case 'byEmail':
        this.sendMethod = 'Correo electrónico';
        break;
      case 'byWhatsApp':
        this.sendMethod = 'WhatsApp';
        break;
      case 'byCall':
        this.sendMethod = 'Llamada telefónica';
        break;
      default: this.sendMethod = 'SMS';
    }
  }

  openZdWidget() {
    this.supportVm.openChat();
  }

  getEmailTargetText() {
    if (this.isEmailTarget()) { return this.sendMethodText.email; }

    const sendMethod = this.choice?.type;
    const sendMethodText = this.sendMethodText[sendMethod];
    if (sendMethodText) { return sendMethodText; }

    return this.sendMethodText.sms;
  }

  ngOnInit() {
    if(this.listCustomer) {
      this.selectCustomer = this.listCustomer[0] ? this.listCustomer[0] : this.listCustomer;
    } else {
      this.selectCustomer = this.customer;
    }
    this.initSmsValidationForm();
    this.countDown();
  }

  ngOnChanges(changes): void {
    this.idCustomer = changes && changes.listCustomer && changes.listCustomer.currentValue[0]
      ? changes.listCustomer.currentValue[0].idCustomer : changes && changes.customer && changes.customer.currentValue
        ? changes.customer.currentValue.idCustomer : changes.listCustomer && changes.listCustomer.currentValue
          ? changes.listCustomer.currentValue.idCustomer : '';
  }

  saveCustomer(customer) {
    this.store.dispatch(new SaveCustomer(customer)).subscribe(saveCustomer => {
      this.vm.setLocalCustomer(saveCustomer?.customerStore?.customer);
      this.sessionEvent.updateHasCustomer({status: true, customer, isAnonymous: false});
    });
  }

  clearToken() {
    this.smsValidationForm.controls.token.setValue('');
  } 
}
